import { render } from "./DiningRecordConfig.vue?vue&type=template&id=829eff3c"
import script from "./DiningRecordConfig.vue?vue&type=script&lang=js"
export * from "./DiningRecordConfig.vue?vue&type=script&lang=js"

import "./DiningRecordConfig.vue?vue&type=style&index=0&id=829eff3c&lang=scss"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__